(function () {
    'use strict';

    // 抽屉重渲染时 innerHTML 会重建整个组件，内联脚本不会再执行；
    // 而购物车页与抽屉可能各渲染一次本 snippet，脚本就会执行两次。
    // 因此：所有监听一律挂在 document 上做委托，并只初始化一次。
    if (window.__ccsoInitialized) return;
    window.__ccsoInitialized = true;

    var QTY_MIN = 1;
    var QTY_MAX = 2;

    function slideOf(el) {
        return el ? el.closest('[data-ccso-slide]') : null;
    }

    /* ── 数量加减 ── */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-dec], [data-qty-inc]');
        if (!btn) return;

        var slide = slideOf(btn);
        var input = slide && slide.querySelector('[data-ccso-qty]');
        if (!input) return;

        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = QTY_MIN;

        input.value = btn.hasAttribute('data-qty-dec')
            ? Math.max(minOf(input), current - 1)
            : Math.min(maxOf(input), current + 1);
    });

    // max 由 Liquid 按「限购数 − 购物车已有数」算出，可能是 1 或 2
    function maxOf(input) {
        var max = parseInt(input.max, 10);
        return isNaN(max) || max < QTY_MIN ? QTY_MAX : max;
    }

    function minOf(input) {
        var min = parseInt(input.min, 10);
        return isNaN(min) ? QTY_MIN : min;
    }

    /* ── 轮播 ── */

    function trackOf(el) {
        var root = el && el.closest('[data-ccso]');
        return root ? root.querySelector('[data-ccso-track]') : null;
    }

    // 以「最靠近轨道中心的那张」为当前项，比用 scrollLeft 取整更耐受
    // 惯性滚动的中间态和最后一张露不满一屏的情况
    function activeIndex(track) {
        var slides = track.querySelectorAll('[data-ccso-slide]');
        var center = track.scrollLeft + track.clientWidth / 2;
        var active = 0;
        var best = Infinity;

        for (var i = 0; i < slides.length; i++) {
            var slideCenter = slides[i].offsetLeft - track.offsetLeft + slides[i].offsetWidth / 2;
            var distance = Math.abs(slideCenter - center);
            if (distance < best) {
                best = distance;
                active = i;
            }
        }
        return active;
    }

    function goTo(track, index) {
        var slides = track.querySelectorAll('[data-ccso-slide]');
        if (!slides.length) return;

        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({
            left: slides[index].offsetLeft - track.offsetLeft,
            behavior: 'smooth'
        });
    }

    /* 圆点点击 */
    document.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-ccso-dot]');
        if (!dot) return;

        var track = trackOf(dot);
        if (track) goTo(track, parseInt(dot.getAttribute('data-ccso-dot'), 10) || 0);
    });

    /* 左右箭头点击 */
    document.addEventListener('click', function (e) {
        var arrow = e.target.closest('[data-ccso-prev], [data-ccso-next]');
        if (!arrow || arrow.disabled) return;

        var track = trackOf(arrow);
        if (!track) return;

        var step = arrow.hasAttribute('data-ccso-prev') ? -1 : 1;
        goTo(track, activeIndex(track) + step);
    });

    /* 跟随滚动同步圆点与箭头状态 ──
       scroll 事件不冒泡，用捕获阶段才能接到动态插入的轨道 */
    var scrollPending = false;

    document.addEventListener('scroll', function (e) {
        var track = e.target;
        if (!track || !track.hasAttribute || !track.hasAttribute('data-ccso-track')) return;
        if (scrollPending) return;

        scrollPending = true;
        requestAnimationFrame(function () {
            scrollPending = false;
            syncControls(track);
        });
    }, true);

    function syncControls(track) {
        var root = track.closest('[data-ccso]');
        if (!root) return;

        var slides = track.querySelectorAll('[data-ccso-slide]');
        var active = activeIndex(track);

        var dots = root.querySelectorAll('[data-ccso-dot]');
        for (var j = 0; j < dots.length; j++) {
            dots[j].classList.toggle('is-active', j === active);
        }

        var prev = root.querySelector('[data-ccso-prev]');
        var next = root.querySelector('[data-ccso-next]');
        if (prev) prev.disabled = active <= 0;
        if (next) next.disabled = active >= slides.length - 1;
    }

    /* ── 加入购物车 ── */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ccso-add]');
        if (btn && !btn.disabled) addToCart(btn);
    });

    async function addToCart(btn) {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var slide = slideOf(btn);
        var qtyInput = slide && slide.querySelector('[data-ccso-qty]');
        var qty = parseInt(qtyInput && qtyInput.value, 10);
        if (isNaN(qty) || qty < QTY_MIN) qty = QTY_MIN;

        // 限量出售：不论输入框被怎么改，都不能超过剩余可购量
        if (qtyInput) {
            qty = Math.min(qty, maxOf(qtyInput));
            qtyInput.value = qty;
        }

        var textEl = btn.querySelector('.qv-atc-text');
        var spinnerEl = btn.querySelector('.qv-atc-spinner');
        var originalText = textEl ? textEl.textContent : '';

        btn.disabled = true;
        if (textEl) textEl.hidden = true;
        if (spinnerEl) spinnerEl.hidden = false;

        // 抽屉不存在时（例如某些落地页）仍然要能加购，只是不刷新抽屉
        var ajaxCart = document.querySelector('ajax-cart');
        var body = { items: [{ id: variantId, quantity: qty }] };

        if (ajaxCart && typeof ajaxCart.getSectionsToRender === 'function') {
            body.sections = ajaxCart.getSectionsToRender().map(function (s) { return s.id; });
        }

        try {
            var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(body)
            });

            if (!res.ok) throw new Error('Cart add failed');

            var data = await res.json();

            btn.classList.add('is-success');
            if (textEl) {
                textEl.textContent = '✓ Added';
                textEl.hidden = false;
            }
            if (spinnerEl) spinnerEl.hidden = true;

            // 购物车页要整页刷新：getSectionsToRender 只重渲染抽屉和角标，
            // 不含 main-cart-items，页面上的购物车表格与本组件都会留在旧状态，
            // 限购数据也就跟着过期 —— 用户可以反复加购突破 2 件上限。
            var root = btn.closest('[data-ccso]');
            var isCartPage = root && root.getAttribute('data-ccso-type') === 'cart-page';

            if (isCartPage) {
                window.location.reload();
                return;
            }

            if (ajaxCart && typeof ajaxCart.renderContents === 'function') {
                // renderContents 会用 innerHTML 重建抽屉，btn 随之被移除，
                // 组件也会按最新的购物车数据重新计算限购，无需手动复原按钮。
                ajaxCart.open();
                ajaxCart.renderContents(data);
            } else {
                window.location.reload();
                return;
            }

            setTimeout(function () {
                if (!btn.isConnected) return;
                btn.classList.remove('is-success');
                btn.disabled = false;
                if (textEl) textEl.textContent = originalText;
            }, 2500);

        } catch (err) {
            console.error('[CCSO] Add to cart error:', err);
            if (textEl) {
                textEl.textContent = 'Error, try again later';
                textEl.hidden = false;
            }
            if (spinnerEl) spinnerEl.hidden = true;
            btn.disabled = false;

            setTimeout(function () {
                if (textEl && btn.isConnected) textEl.textContent = originalText;
            }, 3000);
        }
    }
})();